import { createGlobalStyle } from "styled-components";

import WorkSans from "./fonts/ttf/WorkSans-VariableFont_wght.ttf";
import { ThemeProps } from "./themes/types";

export const GlobalStyle = createGlobalStyle<ThemeProps>`
  @font-face {  /* only loads font, doesn't apply it to anything yet */
    font-family: "WorkSans";
    src: url(${WorkSans});
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul li {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  ol li {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  html: {
    background-color: ${props => props.theme.background};
  }
`;
